interface RatingProps {
  value: number;
  className?: string;
  size?: 'sm' | 'md';
}

export default function Rating({ value, className = '', size = 'md' }: RatingProps) {
  const text = size === 'sm' ? 'text-xs' : 'text-sm';
  const icon = size === 'sm' ? 'text-xs' : 'text-sm';

  return (
    <span className={`inline-flex items-center gap-1 font-heading font-bold text-primary-400 ${text} ${className}`}>
      <i className={`ri-star-fill ${icon}`} aria-hidden="true" />
      <span>{value.toFixed(1)}</span>
    </span>
  );
}